// extracted by mini-css-extract-plugin
module.exports = {"SSvg":"DiceValue_SSvg__Vy2eU","SPath":"DiceValue_SPath__nqLyD"};